import textPt from "./textPt";
import textEn from "./textEn";

const textLanguages = {
  ...textPt,
  ...textEn
};

export { textLanguages };
